module.exports = __webpack_public_path__ + "images/home-workout-knee-to-elbow.jpg";